function Youtube({ dimensions, col = '#000' }) {
  const baseXml = `
   <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M28 56C12.5361 56 0 43.4639 0 28C0 12.536 12.5361 0 28 0C43.464 0 56 12.536 56 28C56 43.4639 43.464 56 28 56Z" fill="#FF0000"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8591 28.0001C10.7717 29.6909 11.141 33.7431 11.141 33.7431C11.5298 39.4958 14.6003 39.4179 17.4185 39.6707C20.2365 39.9233 28.0008 40.0107 28.0008 40.0107C28.0008 40.0107 35.7651 39.9233 38.5831 39.6707C41.4011 39.4179 44.4719 39.4958 44.8607 33.7431C44.8607 33.7431 45.23 29.6909 45.1426 28.0001C45.23 26.3092 44.8607 22.2571 44.8607 22.2571C44.4721 16.5043 41.4013 16.582 38.5831 16.3295C35.7651 16.0769 28.0008 15.9893 28.0008 15.9893C28.0008 15.9893 20.2365 16.0767 17.4185 16.3295C14.6005 16.5822 11.5298 16.5043 11.141 22.2571C11.141 22.2571 10.7717 26.3092 10.8591 28.0001Z" fill="white"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.5605 33.1305V22.8105L33.5395 27.9998L24.5605 33.1305Z" fill="#FF0000"/>
  </svg>


  `;

  return baseXml;
}

export default Youtube;
